import { render, staticRenderFns } from "./employeeOverview.vue?vue&type=template&id=2b398c1a&scoped=true"
import script from "./employeeOverview.vue?vue&type=script&lang=js"
export * from "./employeeOverview.vue?vue&type=script&lang=js"
import style0 from "./employeeOverview.vue?vue&type=style&index=0&id=2b398c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b398c1a",
  null
  
)

export default component.exports